import React from 'react';
import { formatCurrency } from 'react-data-formatter';
import { Container, Installments, Title } from './styles';

function InstallmentDetails({ showInstallmentDetails, installmentDetails }) {
  if (showInstallmentDetails !== true || !Array.isArray(installmentDetails) || installmentDetails.length <= 1) return null;

  return (
    <Container>
      <Title>Detalhamento de Parcelas</Title>
      <Installments>
        {installmentDetails.map(({ number, value, dueMonth }, index) => (
          <React.Fragment key={`${number}-${dueMonth}`}>
            <span>
              {number} - {formatCurrency(value)} - {dueMonth}
            </span>
            {index < installmentDetails.length - 1 && <br />}
          </React.Fragment>
        ))}
      </Installments>
    </Container>
  );
}

export default InstallmentDetails;
